import * as types from "../actions/actionTypes";
import initialState from "./initialState";

export default function dashboardReducer(state = initialState.dashboard, action) {
  switch (action.type) {
    case types.LOAD_OFFER_STATS_SUCCESS:
      return {
        ...state,
        offerStatsData: action.payload
      };

    case types.LOAD_ACTIVITIES_SUCCESS:
      return {
        ...state,
        activities: action.payload
      };

    case types.LOAD_AVERAGE_TIME_STATES_SUCCESS:
      return {
        ...state,
        averageTimeStates: action.payload
      };

    case types.LOAD_ACTIVE_CONTRACT_CHART_DATA_SUCCESS:
      return {
        ...state,
        activeContractChartData: action.payload
      };

    default:
      return state;
  }
}
